import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import AdmissionsDayLanding from '../../components/AdmissionsDay/AdmissionsDayLanding';
import Script from 'next/script';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const Countryadmissionsday: React.FC = (props: any) => {
  if (!props.pageData || props.pageData.length === 0) {
    return <ErrorComponent />;
  }

  return (
    <>
      {/*commented for a single event, to be uncommented later once the event is over*/}
      {/* <Script
        type='text/javascript'
        strategy='beforeInteractive'
        src='https://d10zminp1cyta8.cloudfront.net/widget.js'
      ></Script>
      <Script
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `var widget = new RTWidget({
            "companies": [
              34147
            ],
            "detailsMode": "popup",
            "language": "en",
            "departmentsFilter": [
              "Software Development"
            ],
            "themeVars": {
              "primary": "#1999e3",
              "secondary": "#000",
              "text": "#5c6f78",
              "textDark": "#37474f",
              "baseFontSize": "16px"
            },
            "flags": {
              "showLocation": true,
              "showCountry": true,
              "showCity": true,
              "showState": true,
              "groupByLocation": false,
              "groupByState": false,
              "groupByDepartment": false,
              "groupByCompany": false
            }
            });`,
        }}
      ></Script> */}
      <AdmissionsDayLanding {...props} />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: 'blocking' };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/admissions-day-pages?newSlug=${context.params?.slug}&categoryType=company`,
    'GET',
    {},
    '',
    false
  );
  return {
    props: {
      pageData,
    },
    revalidate: CACHE_REVALIDATE_24H,
  };
};

export default Countryadmissionsday;
